import { FileStack } from "lucide-react";
import { SubSection } from "../SubSection";
import { NavItem } from "../NavItem";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

interface DraftsSectionProps {
  isCollapsed: boolean;
  currentPath: string;
}

// Presentational only — the Sidebar gates rendering on has(CATALOG_UPLOAD) (seller + admin), so this
// section never mounts for buyers/negotiators (single role resolution upstream; no flash).
export function DraftsSection({ isCollapsed, currentPath }: DraftsSectionProps) {
  return (
    <SubSection title="Drafts" icon={FileStack} isCollapsed={isCollapsed}>
      <NavItem
        icon={FileUploadOutlinedIcon}
        label="Upload"
        path="/upload"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/upload"}
      />
      <NavItem
        icon={ModeEditOutlineOutlinedIcon}
        label="Drafts"
        path="/drafts"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/drafts"}
      />
    </SubSection>
  );
}
